import { render, staticRenderFns } from "./Submission.vue?vue&type=template&id=3f78b018&scoped=true&"
import script from "./Submission.vue?vue&type=script&lang=js&"
export * from "./Submission.vue?vue&type=script&lang=js&"
import style0 from "./Submission.vue?vue&type=style&index=0&id=3f78b018&lang=scss&scoped=true&"
import style1 from "./Submission.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f78b018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f78b018')) {
      api.createRecord('3f78b018', component.options)
    } else {
      api.reload('3f78b018', component.options)
    }
    module.hot.accept("./Submission.vue?vue&type=template&id=3f78b018&scoped=true&", function () {
      api.rerender('3f78b018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/edit/Submission.vue"
export default component.exports